import { useCallback, useContext } from "react";
import { AnalyticsContext } from "@swiggy-private/analytics";
import {
    eligibileScreenViewEvent,
    exploreDineoutClickEvent,
    exploreDineoutImpressionEvent,
    tapToClainClickEvent,
    appDownloadClickEvent,
    clickLoginClickEvent,
    loginAndNonAppUserScreenViewEvent,
} from "utils/loyaltyAnalytics";

export const useDineoutAnalytics = () => {
    const { clickEvent, screenViewEvent, impressionEvent } = useContext(AnalyticsContext);

    const onClickTapToClaim = useCallback(
        (params: { cashbackEarned: string; expiryInDays: string; campaignId: number }) => {
            tapToClainClickEvent(clickEvent, params);
        },
        [clickEvent],
    );

    const onEligibileScreenView = useCallback(
        (params: { cashbackEarned: string; expiryInDays: string; campaignId: number; statusCode: number }) => {
            eligibileScreenViewEvent(screenViewEvent, params);
        },
        [screenViewEvent],
    );
    const onExploreDineoutImpression = useCallback(
        (params: { text: string; subText: string }) => {
            exploreDineoutImpressionEvent(impressionEvent, params);
        },
        [impressionEvent],
    );

    const onExploreDineoutClick = useCallback(
        (params: { text: string; subText?: string }) => {
            exploreDineoutClickEvent(clickEvent, params);
        },
        [clickEvent],
    );

    const onAppDownloadClick = useCallback(
        (params: { device: string }) => {
            appDownloadClickEvent(clickEvent, params);
        },
        [clickEvent],
    );

    const onClickLogin = useCallback(
        (params: { clickLogin: string }) => {
            clickLoginClickEvent(clickEvent, params);
        },
        [clickEvent],
    );
    const onLoginAndNonAppUserScreenView = useCallback(
        (params: { cashbackEarned: string; campaignId: number; text: string }) => {
            loginAndNonAppUserScreenViewEvent(screenViewEvent, params);
        },
        [screenViewEvent],
    );

    return {
        onClickTapToClaim,
        onEligibileScreenView,
        onExploreDineoutImpression,
        onExploreDineoutClick,
        onAppDownloadClick,
        onClickLogin,
        onLoginAndNonAppUserScreenView,
    };
};
